import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { NotEnoughMoney } from './not-enough-money';

export class NotEnoughBonusMoney extends NotEnoughMoney {
    constructor(userMoney: number) {
        super(userMoney);
        this.icon = BetPlacementErrorIcon.Warning;
        this.type = PlacementErrorType.InsufficientBonusMoney;
    }
}
